// Module
var code = `<dice-html class="text-bold" content="{{ questionAnswerController.question.labels | description }}"></dice-html> <p>{{ questionAnswerController.text }}</p> `;
// Exports
module.exports = code;